import { CARGO_V2, TRANSPORT as TRANSPORT_API, AUCTION as AUCTION_API, AIR as AIR_API, UTILS as UTILS_API, TRANSPORT_V2 as TRANSPORT_API_V2 } from "endpointsConst";

export const FREIGHTS = {
    add: "/freight/add",
    search: "/freight/search",
    edit: "/freight/edit",
    map: "/freight/map",
    getContacts: `${CARGO_V2}/exchange/:id/contacts/`,
};

export const FREIGHTS_RELATIVE_ROUTES = {
    add: "/add",
    search: "/search",
    edit: "/edit",
    map: "/map/:templateId",
};

export const TRANSPORT = {
    search: "/transport/search",
    add: "/transport/add",
    addToExchange: "/transport/add-to-exchange",
    addToExchangeFromPark: "/transport/add-from-park-to-exchange",
    edit: "/transport/edit",
    park: "/transport/park",
    getContacts: `${TRANSPORT_API_V2}/exchange/:id/contacts/`,
    map: "/transport/map",
};

export const TRANSPORT_RELATIVE_ROUTES = {
    search: "/search",
    add: "/add",
    addToExchange: "/add-to-exchange",
    addToExchangeFromPark: "/add-from-park-to-exchange",
    edit: "/edit",
    park: "/park",
    map: "/map/:templateId",
    getContacts: "/exchange/getContactsById/",
};

export const UTILS = {
    cities: `${UTILS_API}/cities`,
    countries: `${UTILS_API}/countries`,
};

export const AUCTION = {
    auction: "/auction",
    my: "/auction/my-lots",
    add: "/auction/add",
    getContacts: `${AUCTION_API}/getContactsById/`,
};

export const PROFILE = {
    profile: "/profile/company",
    edit: "/profile/company/edit",
    employees: "/profile/employees",
    calculations: "/profile/calculations",
    documents: "/profile/documents",
    park: "/profile/park",
    addTransport: "/profile/park/add",
    editTransport: "/profile/park/edit",
};

export const PROFILE_RELATIVE_ROUTES = {
    profile: "/company",
    edit: "/edit",
    employees: "/employees",
    calculations: "/calculations",
    documents: "/documents",
    park: "/park",
    addTransport: "/park/add",
    editTransport: "/park/edit",
};

export const AIR = {
    search: "/air/search",
    add: "/air/add",
    air: "/air",
    edit: "/air/edit",
    getContacts: `${AIR_API.base}/:id/contacts/`,
};

export const AUTH = {
    auth: "/auth",
    login: "/auth/login",
    forgot: "/auth/forgot",
    registration: "/auth/registration",
    restore: "/restore/:url?",
};
